var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container-circleProgress"},on:{"click":function($event){return _vm.goReport()}}},[_c('canvas',{style:({ width: _vm.width + 'px', height: _vm.height + 'px' }),attrs:{"id":_vm.canvasId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }